import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const usePortfolioAccordionItemStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  accordion: {
    marginTop: '0 !important',
    '& .MuiPaper-root-MuiAccordion-root': {
      marginTop: '0'
    },
    '&.Mui-expanded': {
      marginBottom: '0'
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginLeft: '8px',
      marginRight: '0'
    }
  },
  accordionContent: {
    width: '100%'
  },
  title: {
    padding: '16px 16px 16px 5px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .actionText': {
      display: 'flex',
      alignItems: 'center',
      '& .MuiButton-actionButtonPrimary': {
        padding: '0',
        minWidth: '36px',
        marginLeft: '8px'
      },
      '& .MuiButtonBase-root': {
        marginLeft: '8px'
      }
    }
  },
  titleText: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      marginRight: '4px'
    }
  },
  propertyListItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 16px 8px 24px',
    backgroundColor: palette.shades[200]
  },
  propertyListItemTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      marginRight: '4px'
    }
  },
  activeItem: {
    backgroundColor: palette.success.light
  },
  propertyListItemActions: {
    '& .actionText': {
      display: 'flex',
      alignItems: 'center',
      '& .MuiButton-actionButtonPrimary': {
        padding: '0',
        minWidth: '36px',
        marginLeft: '8px'
      },
      '& .MuiButtonBase-root': {
        marginLeft: '8px'
      }
    }
  }
}));
export default usePortfolioAccordionItemStyles;